import React from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';

import DesignMenu from './DesignMenu';
import SurveySettings from './SurveySettings';
import { SurveyPreviewModal } from './SurveyPreview';

export type SurveyOptionBarProps = {
  imageRef: any;
  values: any;
  placeholdersValues: any;
  componentName: 'Survey' | 'Template';
  accountInfo: any;
};
export const SurveyOptionBar = ({
  // values,
  imageRef,
  placeholdersValues,
  componentName,
  accountInfo,
}: SurveyOptionBarProps) => {
  const { getValues } = useFormContext();
  // console.log(values, setValues)

  const values = getValues();

  return (
    <StyledSurveyOption>
      <div className="menu">
        <div className="menu-item">
          <SurveySettings componentName={componentName} />
        </div>
        <div className="menu-item">
          <DesignMenu imageRef={imageRef} />
        </div>
        <div className="divider" />
        <div className="menu-item">
          <SurveyPreviewModal
            values={values}
            placeholdersValues={placeholdersValues}
            accountInfo={accountInfo}
          />
        </div>
      </div>
    </StyledSurveyOption>
  );
};

export default SurveyOptionBar;

const StyledSurveyOption = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(18, 52, 77, 0.06);
  border-radius: 8px;
  width: 48px;
  .survey-preview-modal {
    margin-bottom: 48px;
  }

  .menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 0 10px;
  }

  .menu-item:hover {
    background: var(--color-smoke-50);
  }
  .menu-item {
    width: 29px;
    height: 29px;
    margin-top: 10px;
    margin-bottom: 5px;
    border-radius: 5px;
    cursor: pointer;
  }

  .divider {
    margin: 5px 0 0;
    border-top: 1px solid #eee;
    height: 1px;
    width: 100%;
  }
`;
